import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'
import gql from 'graphql-tag'

const httpLink = createHttpLink({
  uri: 'https://eu-central-1-shared-euc1-02.cdn.hygraph.com/content/cm0wpc88h02cq07uxfuaeo0gq/master'
})

const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache()
})

const query = gql`
  query Projects {
  projects {
    id
    name
    description
    image {
      url
    }
    projectStatus
    page {
      html
    }
  }
}
`

export const useProjectsStore = defineStore('project', () => {
  const projectsData = ref([])
  const projects = computed(() => projectsData)
  
  function init() {
    apolloClient
      .query({
        query
      })
      .then(({ data }) => {
        projectsData.value = data.projects
      });
  }

  
  return { projects, init }
})
